var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinewitDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 472.16 21.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b498c6;}.cls-2{fill:none;stroke-miterlimit:10;stroke-width:1.91px;stroke:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -193.33,
    y1: 5.56,
    x2: 168.43,
    y2: 5.56,
    gradientTransform: "matrix(1.28, 0, 0, 1, 246.55, 3.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b498c6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENTORNEWAPPLICATIONS_copy",
    "data-name": "MENTORNEWAPPLICATIONS copy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.34,
    cy: 10.82,
    r: 10.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    y1: 8.6,
    x2: 461.34,
    y2: 8.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinewitDot);
export default __webpack_public_path__ + "static/media/Line wit Dot.682d0bf4bb04d0a60fb07741288427d6.svg";
export { ForwardRef as ReactComponent };